import { Language } from '../../../../../common';

export class NewsletterSubscribeConfirmation {
  public static readonly type = '[Newsletter Subscription] Subscribe Confirmation';
  constructor(public payload: string) {}
}

export class NewsletterSubscribe {
  public static readonly type = '[Newsletter Subscription] Subscribe';
  constructor(public payload: Language) {}
}

export class NewsletterSubscriptionInitialState {
  public static readonly type = '[Newsletter Subscription] Set Initial State';
}
